import { useState } from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/feature/Seo";
import { gkFaqs } from "@/mocks/faqs";

const SITE = "https://dqxuaad.cn";

export default function Faq() {
  const groups = ["关于瓜料", "关于栏目", "关于投稿", "关于权益"];
  const [active, setActive] = useState<string | null>(null);
  const filtered = gkFaqs.filter((f) => (active ? f.group === active : true));

  return (
    <>
      <Seo
        title="看吃瓜常见问题 - 更新与投稿FAQ"
        description="关于看吃瓜每日瓜料更新节奏、栏目设置、瓜料可靠性、投稿方式与转载权益的常见问题解答。"
        canonicalPath="/faq"
        jsonLd={[
          { "@context": "https://schema.org", "@type": "BreadcrumbList", itemListElement: [{ "@type": "ListItem", position: 1, name: "看吃瓜", item: SITE }, { "@type": "ListItem", position: 2, name: "常见问题", item: `${SITE}/faq` }] },
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: gkFaqs.map((f) => ({
              "@type": "Question",
              name: f.question,
              acceptedAnswer: { "@type": "Answer", text: f.answer },
            })),
          },
        ]}
      />

      <div className="mx-auto max-w-7xl px-4 py-8 md:px-8 md:py-12">
        <nav aria-label="面包屑" className="mb-6 flex items-center gap-2 text-xs text-foreground-500">
          <Link to="/" className="hover:text-primary-600">首页</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-foreground-700">常见问题</span>
        </nav>

        <div className="mb-8 max-w-2xl">
          <p className="mb-2 flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600"><span className="inline-block h-px w-6 bg-primary-500"></span>吃瓜百科</p>
          <h1 className="font-heading text-3xl font-bold text-foreground-950 md:text-4xl">常见问题</h1>
          <p className="mt-3 text-sm leading-7 text-foreground-600">关于每日瓜料更新、栏目划分、投稿线索与转载权益，常见疑问这里一次说清。</p>
        </div>

        {/* Group filter */}
        <div className="mb-8 flex flex-wrap gap-2">
          <button type="button" onClick={() => setActive(null)} className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${!active ? "bg-primary-500 text-background-50" : "bg-background-50 text-foreground-700 ring-1 ring-background-200 hover:text-primary-600"}`}>全部问题</button>
          {groups.map((g) => (
            <button key={g} type="button" onClick={() => setActive(active === g ? null : g)} className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${active === g ? "bg-primary-500 text-background-50" : "bg-background-50 text-foreground-700 ring-1 ring-background-200 hover:text-primary-600"}`}>{g}</button>
          ))}
        </div>

        <div className="grid gap-10 lg:grid-cols-3">
          <div className="space-y-3 lg:col-span-2">
            {filtered.map((f, i) => (
              <FaqItem key={f.question} q={f.question} a={f.answer} index={i} />
            ))}
            {filtered.length === 0 && <p className="rounded-2xl border border-background-200 bg-background-50 p-8 text-center text-foreground-600">该分类暂无问题。</p>}
          </div>
          <aside className="space-y-5">
            <div className="rounded-3xl border border-background-200 bg-background-50 p-6">
              <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-900"><i className="ri-question-line text-primary-500"></i>还有疑问？</h2>
              <p className="mt-2 text-sm leading-6 text-foreground-600">没找到想了解的问题？欢迎通过投稿与联系邮箱告诉我们，我们会尽快补充解答。</p>
              <Link to="/about" className="mt-4 inline-block rounded-full bg-primary-500 px-5 py-2 text-sm whitespace-nowrap text-background-50 hover:bg-primary-600">去联系编辑部</Link>
            </div>
            <div className="overflow-hidden rounded-3xl bg-primary-500 p-6 text-background-50">
              <i className="ri-water-flash-fill text-2xl"></i>
              <h3 className="mt-2 font-heading text-xl font-bold">先吃为敬</h3>
              <p className="mt-2 text-sm text-background-50/90">问题解决后，不如去今日新瓜看看今天有什么值得吃的瓜？</p>
              <Link to="/" className="mt-4 inline-block rounded-full bg-background-50 px-5 py-2 text-sm whitespace-nowrap text-primary-600 hover:bg-background-100">去吃今日的瓜</Link>
            </div>
          </aside>
        </div>
      </div>
    </>
  );
}

function FaqItem({ q, a, index }: { q: string; a: string; index: number }) {
  const [open, setOpen] = useState(index === 0);
  return (
    <div className="overflow-hidden rounded-2xl border border-background-200 bg-background-50">
      <button type="button" onClick={() => setOpen((v) => !v)} aria-expanded={open} className="flex w-full items-center gap-3 p-5 text-left">
        <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-bold ${open ? "bg-primary-500 text-background-50" : "bg-background-100 text-primary-600"}`}>Q</span>
        <h2 className="flex-1 font-heading text-base font-bold text-foreground-900 md:text-lg">{q}</h2>
        <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${open ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"}`}>
          <i className={`ri-add-line transition-transform ${open ? "rotate-45" : ""}`}></i>
        </span>
      </button>
      {open && (
        <div className="flex gap-3 border-t border-background-200 px-5 py-5">
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-accent-100 text-sm font-bold text-accent-700">A</span>
          <p className="flex-1 text-sm leading-7 text-foreground-700">{a}</p>
        </div>
      )}
    </div>
  );
}